var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"btn-float",attrs:{"color":(!_vm.isListening) ? 'primary' : 'error',"dark":"","normal":"","fab":""},on:{"click":_vm.onToggleDictado}},[(_vm.isListening)?_c('v-icon',{attrs:{"dense":"","size":"25px"}},[_vm._v("mdi-stop")]):_c('v-icon',{attrs:{"dense":"","size":"25px"}},[_vm._v("mdi-microphone")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }